import React, { useState } from "react"
import { Row, Col, AutoComplete } from "antd"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
  getAddressFromCoord,
  updateAddress,
  fetchAddressAutoComplete,
} from "../../redux/actionCreators/auth"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"
import { validateUserAddress } from "../../redux/actionCreators/planDinnner"
import "./GetAddress.scss"
import {
  NOT_SUPPORTED_FEEDBACK,
  ADDRESS_LABEL,
  ABOUT_YOU_SAVE_PREFERENCES_BUTTON,
  ENABLE_LOCATION_BUTTON,
  BACK_BUTTON,
  RESTAURANT_SELECT_LABEL,
  DELIVERY_ADDRESS_PLACEHOLDER,
} from "../../constants/messages"
import { FirebaseContext, FirebaseService } from "../../firebase"
import { FIREBASE_STATE_KEYS } from "../../firebase"
import _ from "../../utils/lodashUtils"
import { AimOutlined, ArrowLeftOutlined } from "@ant-design/icons"
import { PageHeader } from "../../molecules/PageHeader"
import { Button, TextTag as Text, SearchBar } from "../../atoms"

const GetAddress = (props) => {
  // TODO: Commented this as per discussion with bhargavi, confirm address goes at end during checkout
  // const [addressManualMode, setAddressManualMode] = useState(false)
  const [address, setAddress] = useState("")
  const [permissionDisabled, setpermissionDisabled] = useState(false)
  const [addressOptions, setAddressOptions] = useState([])
  const { Option } = AutoComplete
  const firebaseDefaultPath = FirebaseService.getDefaultPath()

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(setLocationData, () => {
        FirebaseService.patch(
          {
            [FIREBASE_STATE_KEYS.GEO_LOCATION]: "DENIED",
          },
          `${firebaseDefaultPath}${props.user.uuid}/${[
            FIREBASE_STATE_KEYS.USER_DETAILS,
          ]}`
        )
        setpermissionDisabled(true)
      })
    } else {
      alert(NOT_SUPPORTED_FEEDBACK)
    }
  }
  async function setLocationData(position) {
    getAddressFromCoord(
      position.coords.latitude,
      position.coords.longitude
    ).then((data) => {
      if (data && data.address) {
        setAddress(data.address)
      }
      FirebaseService.patch(
        {
          [FIREBASE_STATE_KEYS.GEO_LOCATION]: "ACCEPTED",
        },
        `${firebaseDefaultPath}${props.user.uuid}/${[
          FIREBASE_STATE_KEYS.USER_DETAILS,
        ]}`
      )
    })
  }

  const handleSearch = async (value) => {
    setAddress(value)
    if (value) {
      let addresses = await props.fetchAddressAutoComplete(value)
      setAddressOptions(addresses.data)
    }
  }

  const children = addressOptions.map((address) => (
    <Option key={address.id} value={address.description}>
      {address.description}
    </Option>
  ))

  const onSelect = (value) => {
    setAddress(value)
  }

  const { userState } = React.useContext(FirebaseContext)
  const permissionDenied = _.get(
    userState,
    `${FIREBASE_STATE_KEYS.USER_DETAILS}.${FIREBASE_STATE_KEYS.GEO_LOCATION}`,
    ""
  )
  return (
    <div id="GetAddress">
      <div className="get-address-pageHeader">
        <PageHeader
          btnText={BACK_BUTTON}
          icon={<ArrowLeftOutlined />}
          headerText={RESTAURANT_SELECT_LABEL}
        />
      </div>
      {/* TODO: Commented this as per discussion with bhargavi, confirm address goes at end during checkout */}
      {
        // !addressManualMode && address ?
        // <div>
        //     <Row id="HeaderRow">
        //         <Text strong>We detect this as your address. Is that right?</Text>
        //     </Row>
        //     <Row id="HeaderRow" className="addressRow">
        //         <Col id="addressText">
        //             <Text>{address}</Text>
        //         </Col>
        //         <Col id="ButtonContainer">
        //             <Row>
        //                 <Col className="InputButton">
        //                     <Button type="primary" onClick={()=>props.updateAddress(address)}>Confirm</Button>
        //                 </Col>
        //                 <Col className="InputButton">
        //                     <Button type="ghost" onClick={()=>setAddressManualMode(true)} className="secondaryButton"> Edit</Button>
        //                 </Col>
        //             </Row>
        //         </Col>
        //     </Row>
        // </div>
        // :
        <div className="address-box">
          <Row id="HeaderRow">
            <Text>{ADDRESS_LABEL}</Text>
          </Row>
          <Row id="addressRow" className="addressRow">
            <Col>
              {(!address || address === "") && permissionDenied !== "DENIED" ? (
                <SearchBar
                  placeholder={DELIVERY_ADDRESS_PLACEHOLDER}
                  className="search-bar"
                  value={address}
                  onSearch={handleSearch}
                  onSelect={onSelect}
                  allowClear={true}
                />
              ) : (
                <SearchBar
                  placeholder={DELIVERY_ADDRESS_PLACEHOLDER}
                  className="search-bar"
                  value={address}
                  onSearch={handleSearch}
                  onSelect={onSelect}
                  allowClear={true}
                >
                  {address ? children : null}
                </SearchBar>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <div id="locationRow" onClick={() => getLocation()}>
                <Text textType="smallTextPrimary">
                  {ENABLE_LOCATION_BUTTON}
                </Text>
              </div>
            </Col>
          </Row>
          <div id="ButtonContainer">
            <Button
              btnType="primary"
              onClick={() => {
                props.validateUserAddress(address, "", () =>
                  props.updateAddress(address)
                )
              }}
              disabled={address ? !address.trim() : true}
            >
              <Text textType="smallTextPrimary">
                {ABOUT_YOU_SAVE_PREFERENCES_BUTTON}
              </Text>
            </Button>
          </div>
        </div>
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  addressList: state.auth.addressSuggested,
})

export default connect(mapStateToProps, {
  fetchPartnerDetails,
  updateAddress,
  fetchAddressAutoComplete,
  validateUserAddress,
})(withRouter(GetAddress))
